import { useSEO, SOCIAL_IMAGE } from '@/hooks/useSEO';
import Navbar from '@/pages/home/components/Navbar';
import Footer from '@/pages/home/components/Footer';
import InvolvedHero from './components/InvolvedHero';
import ActionCards from './components/ActionCards';
import InvolvedCTA from './components/InvolvedCTA';

export default function InvolvedPage() {
  useSEO({
    title: 'Get Involved with CSCF Support | Raise Awareness for Cardiospondylocarpofacial Syndrome',
    description:
      'Get involved with CSCF Support. Share awareness, join the community, participate in rare disease advocacy, and support research for Cardiospondylocarpofacial syndrome.',
    keywords:
      'get involved CSCF, CSCF awareness, Cardiospondylocarpofacial syndrome advocacy, rare disease awareness, CSCF volunteer, support CSCF research',
    canonical: `${import.meta.env.VITE_SITE_URL ?? 'https://cscfsupport.org'}/get-involved`,
    ogImage: SOCIAL_IMAGE,
    breadcrumbs: [
      { name: 'Home', url: `${import.meta.env.VITE_SITE_URL ?? 'https://cscfsupport.org'}/` },
      { name: 'Get Involved', url: `${import.meta.env.VITE_SITE_URL ?? 'https://cscfsupport.org'}/get-involved` },
    ],
    structuredData: [
      {
        '@context': 'https://schema.org',
        '@type': 'WebPage',
        name: 'Get Involved — CSCF Support',
        url: `${import.meta.env.VITE_SITE_URL ?? 'https://cscfsupport.org'}/get-involved`,
        description:
          'Ways to get involved with CSCF Support: raise awareness, join the community, and support research for Cardiospondylocarpofacial syndrome.',
        isPartOf: { '@type': 'WebSite', name: 'CSCF Support', url: `${import.meta.env.VITE_SITE_URL ?? 'https://cscfsupport.org'}/` },
        about: {
          '@type': 'MedicalCondition',
          name: 'Cardiospondylocarpofacial Syndrome',
          alternateName: ['CSCF', 'CSCFS'],
        },
        mainEntity: {
          '@type': 'ItemList',
          name: 'Ways to Support CSCF Awareness',
          itemListElement: [
            { '@type': 'ListItem', position: 1, name: 'Share Your CSCF Story' },
            { '@type': 'ListItem', position: 2, name: 'Spread Awareness on Social Media' },
            { '@type': 'ListItem', position: 3, name: 'Participate in CSCF Research' },
            { '@type': 'ListItem', position: 4, name: 'Join the CSCF Community' },
            { '@type': 'ListItem', position: 5, name: 'Support Rare Disease Advocacy' },
          ],
        },
      },
    ],
  });

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <InvolvedHero />
      <ActionCards />
      <InvolvedCTA />
      <Footer />
    </div>
  );
}
